import dayjs from 'dayjs';

export function formatDate(date: string = '') {
  return dayjs(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY');
}
